import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate } from "@angular/router";
import { VIPService } from "./vip.service";

@Injectable()
export class I18nDataGuard implements CanActivate {
    constructor(private vipService: VIPService) {}
    public async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
        if (!route.data || !route.data.vipConfig) {
            console.error("vip configuration not found.");
            return true;
        }

        // Errors will be handled in vip service.
        await this.vipService.initLazyModuleData(route.data.vipConfig);
        return true;
    }
}
